import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private snackBar: MatSnackBar, private zone: NgZone) {}

  handleError(error: any): void {
    this.zone.run(() => {
      this.snackBar.open('An unexpected error occurred.', 'Dismiss', { duration: 5000 });
    });
    console.error('Global error:', error);
  }
}
